const servicesAr = [
  {
    title: "Trax",
    tagline: "منصة المراقبة الموحدة والتحكم النشط بالبنية التحتية",
    description: "منصة خفيفة الوزن وعالية الأداء وقابلة للاستضافة الذاتية مبنية بلغة Rust، تجمع بين المراقبة الشاملة للنظام (تتبع الأخطاء، التتبع الموزع، تسجيل الجلسات، تحليل الأداء، وقت التشغيل) والتحكم النشط في البنية التحتية (مراقبة الخوادم وإدارة الأجهزة عن بُعد) مع المعالجة التلقائية للأعطال.",
    features: [
      "مراقبة شاملة للأنظمة: تتبع الأخطاء، التتبع الموزع، تحليل الأداء ووقت التشغيل",
      "إدارة الخوادم النشطة: مراقبة مباشرة وإدارة أجهزة الخوادم الطرفية عن بُعد",
      "محرك أصلي بلغة Rust: مبني بـ Actix-web و Tokio و WebSockets و SQLx وتشفير AES-GCM",
      "أداء فائق واستضافة ذاتية: نشر فوري كحاوية Docker واحدة أو على العتاد المباشر"
    ],
    link: "https://github.com/samirdjelal/trax",
    tags: ["Rust", "Actix-web", "Tokio", "WebSockets", "مراقبة الأنظمة", "DevOps"],
    category: "المراقبة والبنية التحتية",
    isFlagship: true
  },
  {
    title: "Hydra-gate",
    tagline: "مجمع وكلاء SOCKS5 وموازن تحميل ديناميكي",
    description: "مجمع وكيل SOCKS5 خفيف الوزن وموازن تحميل مبني باستخدام Tauri و Rust. يقوم بتدوير حركة المرور عبر وكلاء متعددين مع فحوصات تلقائية للصحة.",
    link: "https://github.com/samirdjelal/hydra-gate",
    tags: ["Rust", "Tauri", "وكيل", "موازن تحميل", "شبكات"],
    category: "الشبكات والأمان"
  },
  {
    title: "Load-nexus",
    tagline: "أداة اختبار حمل واجهات API فائقة السرعة ومتعددة الخيوط",
    description: "أداة اختبار حمل API عالية الأداء مبنية باستخدام Rust و Tauri. توفر مقاييس فورية، وتحليل أوقات الاستجابة P99، ومحركاً متعدد الخيوط للمطورين العصريين.",
    link: "https://github.com/samirdjelal/load-nexus",
    tags: ["Rust", "Tauri", "اختبار الحمل", "قياس الأداء"],
    category: "أدوات المطورين"
  },
  {
    title: "TxChk",
    tagline: "فحص وتدقيق أرقام BIN للبطاقات المالية",
    description: "التحقق من أرقام تعريف البنوك (BIN) لبطاقات الائتمان والحصول على معلومات تفصيلية عن البنك المصدر، نوع البطاقة، وفئتها وبلد الإصدار.",
    link: "https://txchk.samirdjelal.com/",
    tags: ["تقنية مالية", "فاحص BIN", "أمان", "تحقق"],
    category: "التقنية المالية والأمان"
  },
  {
    title: "Mail-dev",
    tagline: "خادم بريد SMTP محلي مع لوحة تحكم ويب",
    description: "خادم SMTP محلي متعدد المنصات لاختبار وتصحيح رسائل البريد الإلكتروني البرمجية بأمان دون إرسالها خارجياً.",
    link: "https://github.com/samirdjelal/mail-dev",
    tags: ["SMTP", "اختبار", "بريد إلكتروني", "متعدد المنصات"],
    category: "أدوات المطورين"
  },
  {
    title: "Captcha-rs",
    tagline: "مولد صور التحقق بدون اعتماديات خارجية بلغة Rust",
    description: "توليد صور التحقق (Captcha) عالية العشوائية ديناميكياً مع فلاتر تشويش مخصصة ومحرك رسومي سريع بلغة Rust.",
    link: "https://github.com/samirdjelal/captcha-rs",
    tags: ["Rust", "مكتبة", "أمان", "رؤية حاسوبية"],
    category: "الشبكات والأمان"
  },
  {
    title: "Bidirectional",
    tagline: "معالج نصوص يونيكود للغة العربية في البرامج غير الداعمة",
    description: "معالجة وإعادة كتابة النصوص العربية ثنائية الاتجاه لتظهر بشكل سليم في التطبيقات والبرمجيات التي لا تدعم الكتابة من اليمين إلى اليسار.",
    link: "https://github.com/samirdjelal/bidirectional",
    tags: ["عربي", "يونيكود", "BiDi", "معالجة النصوص"],
    category: "أدوات المطورين"
  },
  {
    title: "DecisionRules",
    tagline: "محرك قرارات سحابي وإدارة قواعد الأعمال",
    description: "محرك قرارات سحابي متقدم لإدارة وتقييم قواعد الأعمال البرمجية المعقدة وسير العمل الآلي.",
    link: "https://decisionrule.com/",
    tags: ["سحابي", "محرك قواعد", "SaaS", "أتمتة"],
    category: "أدوات المطورين"
  }
];

export default servicesAr;
